import {ReactComponent as CalendarIcon} from 'icons/calendar.svg'
import {ReactComponent as ClockIcon} from 'icons/clock.svg'
import {ReactComponent as UsersIcon} from 'icons/users.svg'
import {ReactNode} from 'react'
import {Ventrata} from 'types'
import {formatAvailabilityId} from 'utils/formatAvailabilityId'
import {formatMoney} from 'utils/formatMoney'
import {formatUnitItems} from 'utils/formatUnitItems'
import {Card} from './Card'
import {Image} from './Image'

type Props = {
  booking: Ventrata.Booking
  children?: ReactNode
  className?: string
}

export const CartItemData = ({booking, children, className}: Props) => {
  return (
    <Card
      className={className}
      image={<Image src={booking.option.coverImageUrl} title={booking.option.title} />}
      header={
        <div className="flex flex-col gap-2">
          <div className="font-bold text-lg">{booking.option.title}</div>
          {booking.option.duration && (
            <div className="hidden @[407px]:flex items-center gap-2 text-text-secondary">
              <ClockIcon />
              <span>{booking.option.duration}</span>
            </div>
          )}
        </div>
      }
      main={
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <UsersIcon />
              <div>{formatUnitItems(booking.unitItems)}</div>
            </div>
            <div className="flex items-center gap-2">
              <CalendarIcon />
              <div>{formatAvailabilityId(booking.availabilityId, 'dddd, MMM DD, YYYY • HH:mm')}</div>
            </div>
          </div>
          <div className="flex justify-between items-center">
            {children || <div />}
            <div className="flex flex-col items-end">
              <div className="font-bold">{formatMoney(booking.pricing?.retail, booking.pricing?.currency)}</div>
              {booking.pricing?.retail !== booking.pricing?.original && (
                <div className="text-gray-2 text-xs">
                  {formatMoney(booking.pricing?.original, booking.pricing?.currency)}
                </div>
              )}
            </div>
          </div>
        </div>
      }
    />
  )
}
